/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddNews200ResponseSchema } from '../models/AddNews200ResponseSchema';
import type { AddNewsRequestSchema } from '../models/AddNewsRequestSchema';
import type { DeleteNews200ResponseSchema } from '../models/DeleteNews200ResponseSchema';
import type { DeleteNewsRequestSchema } from '../models/DeleteNewsRequestSchema';
import type { ListNews200ResponseSchema } from '../models/ListNews200ResponseSchema';
import type { ListNewsRequestSchema } from '../models/ListNewsRequestSchema';
import type { UpdateNews200ResponseSchema } from '../models/UpdateNews200ResponseSchema';
import type { UpdateNewsRequestSchema } from '../models/UpdateNewsRequestSchema';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class NewsService {

    /**
     * listNews
     * list News
     * @param requestBody
     * @returns ListNews200ResponseSchema ListNews200Response
     * @throws ApiError
     */
    public static listNews(
        requestBody?: ListNewsRequestSchema,
    ): CancelablePromise<ListNews200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/listNews',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `ListNews400Response`,
            },
        });
    }

    /**
     * addNews
     * add News
     * @param requestBody
     * @returns AddNews200ResponseSchema AddNews200Response
     * @throws ApiError
     */
    public static addNews(
        requestBody?: AddNewsRequestSchema,
    ): CancelablePromise<AddNews200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/addNews',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `AddNews400Response`,
            },
        });
    }

    /**
     * updateNews
     * update News
     * @param requestBody
     * @returns UpdateNews200ResponseSchema UpdateNews200Response
     * @throws ApiError
     */
    public static updateNews(
        requestBody?: UpdateNewsRequestSchema,
    ): CancelablePromise<UpdateNews200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/updateNews',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `UpdateNews400Response`,
            },
        });
    }

    /**
     * deleteNews
     * deleteNews
     * @param requestBody
     * @returns DeleteNews200ResponseSchema DeleteNews200Response
     * @throws ApiError
     */
    public static deleteNews(
        requestBody?: DeleteNewsRequestSchema,
    ): CancelablePromise<DeleteNews200ResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/deleteNews',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `DeleteNews400Response`,
            },
        });
    }

}
